import { AxiosResponse } from 'axios';

import { SalesResponse } from './dto/Sales';
import BaseApi from './BaseApi';

const saleApi = {
  initSale(
    token: string,
    payload: {
      accountId?: number;
      amount?: number;
      companyId?: number;
      tokenCount?: number;
      tokenName?: string;
      personal?: boolean;
    }
  ): Promise<AxiosResponse<SalesResponse>> {
    return BaseApi.post('/api/v1/sales', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAgreement(
    token: string,
    payload: {
      saleId: number;
      accountId: number;
      signed: boolean;
      type?: 'AGREEMENT' | 'COUNTER_APPLICATION' | 'PAYMENT_CONFIRMATION';
    }
  ): Promise<AxiosResponse<ArrayBuffer>> {
    const { saleId, accountId, signed = false, type } = payload;
    return BaseApi.get(
      `/api/v1/sales/${saleId}/agreement?accountId=${accountId}&signed=${signed}&type=${type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer',
      }
    );
  },
  paymentUpload(
    token: string,
    payload: {
      id: number;
      file: Blob;
    }
  ): Promise<AxiosResponse<any>> {
    const formData = new FormData();
    formData.append('document', payload.file);

    return BaseApi.post(
      `/api/v1/sales/payment/upload?id=${payload.id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },
  signAgreement(
    token: string,
    payload: {
      hash: string;
      checksum: string;
      signature: string;
      accountId: number;
      operationId: number;
    }
  ): Promise<AxiosResponse<SalesResponse>> {
    return BaseApi.post(`/api/v1/sales/sign`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  signHold(
    token: string,
    payload: {
      operationId: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.post(`/api/v1/sales/hold/init`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  signHoldPublish(
    token: string,
    payload: {
      operationId: number;
      data: string;
      publicKey: string;
    }
  ): Promise<AxiosResponse<SalesResponse>> {
    return BaseApi.post(`/api/v1/sales/hold/transaction/send`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  paymentConfirm(
    token: string,
    payload: {
      id: number;
      signature: string;
      payload: { from: number; to: number; value: number; key: string };
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.post(
      `/api/v1/sales/accept/init?id=${payload.id}`,
      {
        signature: payload.signature,
        payload: payload.payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  paymentConfirmPublish(
    token: string,
    payload: {
      operationId: number;
      data: string;
      publicKey: string;
    }
  ): Promise<AxiosResponse<SalesResponse>> {
    return BaseApi.post(`/api/v1/sales/accept/transaction/send`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getLastSale(
    token: string,
    payload: {
      accountId: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.get(
      `/api/v1/sales/last/inprogress?accountId=${payload.accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getSale(
    token: string,
    payload: {
      id: number;
      accountId: number;
    }
  ): Promise<AxiosResponse<any>> {
    return BaseApi.get(
      `/api/v1/sales/${payload.id}?accountId=${payload.accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};

export default saleApi;
